import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import PropTypes from "prop-types";
import "../../../styles/table.css";

const CompaniesTable = ({ data, page, sizePerPage, onTableChange, totalSize, titleTable }) => {
  const columns = titleTable.map((title, index) => ({
    dataField: `column${index}`,
    text: title,
    headerAlign: "center",
    align: "center",
  }));

  const formattedData = data.map((item, index) => ({
    id: index,
    column0: item?.attendee?.companyName,
    column1: item?.sector,
    column2: item?.maturityType?.label,
    column3: item?.[5]?.ratingTotalEstimate,
    column4: item?.[6]?.ratingTotalEstimate,
    column5: item?.[7]?.ratingTotalEstimate,
    column6: item?.[8]?.ratingTotalEstimate,
    column7: item?.[9]?.ratingTotalEstimate,
    column8: item?.[10]?.ratingTotalEstimate,
    column9: item?.[3]?.ratingTotalEstimate,
    column10: item?.[0]?.ratingTotalEstimate,
    column11: item?.[1]?.ratingTotalEstimate,
    column12: item?.[2]?.ratingTotalEstimate,
    column13: item?.[4]?.ratingTotalEstimate,
  }));

  return (
      <div className="wrapperTable">
        <BootstrapTable
            remote
            striped
            hover
            condensed
            bordered={false}
            keyField="id"
            data={formattedData}
            columns={columns}
            pagination={paginationFactory({ page, sizePerPage, totalSize })}
            onTableChange={onTableChange}
        />
      </div>
  );
};

CompaniesTable.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  totalSize: PropTypes.number.isRequired,
  titleTable: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CompaniesTable;
